import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';

import { ToggleSwitchModule } from '@openng/optimus-ui/toggleswitch';
import { BinaryControlConnectorComponent } from '../control-value-accessor.connector';
import { BaseFormControlDirective, BaseFormControlDirectiveInputs } from '../directives/base-form-control.directive';
import {
  CheckboxFormControlDirective,
  ToggleSwitchFormControlDirectiveInputs,
} from '../directives/checkbox-form-control.directive';
import { FormFieldHelpComponent } from '../form-field-help/form-field-help.component';

/**
 * Přepínač (p-toggleswitch) s popiskem vpravo. API je kompatibilní s ui-checkbox,
 * výměna v šabloně je jen změna tagu.
 */
@Component({
  selector: 'ui-toggle-switch',
  templateUrl: './toggle-switch.component.html',
  imports: [CommonModule, ToggleSwitchModule, ReactiveFormsModule, FormFieldHelpComponent],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: ToggleSwitchComponent,
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  hostDirectives: [
    {
      directive: BaseFormControlDirective,
      inputs: BaseFormControlDirectiveInputs,
    },
    {
      directive: CheckboxFormControlDirective,
      inputs: ToggleSwitchFormControlDirectiveInputs,
    },
  ],
})
export class ToggleSwitchComponent extends BinaryControlConnectorComponent {
  readonly toggle = inject(CheckboxFormControlDirective);
}
